var z = Object.defineProperty;
var q = (e, t, r) => t in e ? z(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var v = (e, t, r) => (q(e, typeof t != "symbol" ? t + "" : t, r), r);
import { q as H } from "./lib-e67158cc.js";
new TextEncoder();
const L = new TextDecoder(), K = (e) => {
  const t = atob(e), r = new Uint8Array(t.length);
  for (let n = 0; n < t.length; n++)
    r[n] = t.charCodeAt(n);
  return r;
}, G = (e) => {
  let t = e;
  t instanceof Uint8Array && (t = L.decode(t)), t = t.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "");
  try {
    return K(t);
  } catch {
    throw new TypeError("The input to be decoded is not correctly encoded.");
  }
};
class X extends Error {
  static get code() {
    return "ERR_JOSE_GENERIC";
  }
  constructor(t) {
    var r;
    super(t), this.code = "ERR_JOSE_GENERIC", this.name = this.constructor.name, (r = Error.captureStackTrace) === null || r === void 0 || r.call(Error, this, this.constructor);
  }
}
class d extends X {
  constructor() {
    super(...arguments), this.code = "ERR_JWT_INVALID";
  }
  static get code() {
    return "ERR_JWT_INVALID";
  }
}
function Y(e) {
  return typeof e == "object" && e !== null;
}
function Q(e) {
  if (!Y(e) || Object.prototype.toString.call(e) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(e) === null)
    return !0;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
const Z = G;
function tt(e) {
  if (typeof e != "string")
    throw new d("JWTs must use Compact JWS serialization, JWT must be a string");
  const { 1: t, length: r } = e.split(".");
  if (r === 5)
    throw new d("Only JWTs using Compact JWS serialization can be decoded");
  if (r !== 3)
    throw new d("Invalid JWT");
  if (!t)
    throw new d("JWTs must contain a payload");
  let n;
  try {
    n = Z(t);
  } catch {
    throw new d("Failed to base64url decode the payload");
  }
  let o;
  try {
    o = JSON.parse(L.decode(n));
  } catch {
    throw new d("Failed to parse the decoded payload as JSON");
  }
  if (!Q(o))
    throw new d("Invalid JWT Claims Set");
  return o;
}
const g = "/bossjob-api-server", rt = async ({
  redirect_uri: e,
  app_num: t = 1
}) => {
  const r = `${g}/authentication/x-auth-token?callback_url=${encodeURIComponent(e)}&app_num=${t}`;
  return fetch(r).then((n) => n.json());
}, nt = async ({
  owner_key: e,
  owner_secret: t,
  oauth_verifier: r,
  app_num: n = 1
}) => {
  const o = `${g}/authentication/through-verify-get-x-user?verify=${r}&owner_key=${e}&owner_secret=${t}&app_num=${n}`;
  return fetch(o).then((s) => s.json());
}, ot = async ({
  code: e,
  redirect_uri: t,
  app_num: r
}) => {
  const n = { grant_type: "authorization_code", code: e, redirect_uri: t, app_num: r };
  return fetch(`${g}/authentication/line-token`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    body: H.stringify(n)
  }).then((o) => o.json());
}, st = async ({
  social_type: e,
  social_user_id: t
}) => {
  const r = `${g}/authentication/check-exist-social-user?social_type=${e}&social_user_id=${t}`;
  return fetch(r).then((n) => n.json());
};
function ee(e) {
  return e && typeof e.then == "function";
}
Promise.resolve(!1);
Promise.resolve(!0);
var f = Promise.resolve();
function B(e, t) {
  return e || (e = 0), new Promise(function(r) {
    return setTimeout(function() {
      return r(t);
    }, e);
  });
}
function te(e, t) {
  return Math.floor(Math.random() * (t - e + 1) + e);
}
function _() {
  return Math.random().toString(36).substring(2);
}
var b = 0;
function h() {
  var e = Date.now() * 1e3;
  return e <= b && (e = b + 1), b = e, e;
}
var re = h, ne = "native";
function oe(e) {
  var t = {
    time: h(),
    messagesCallback: null,
    bc: new BroadcastChannel(e),
    subFns: []
    // subscriberFunctions
  };
  return t.bc.onmessage = function(r) {
    t.messagesCallback && t.messagesCallback(r.data);
  }, t;
}
function se(e) {
  e.bc.close(), e.subFns = [];
}
function ie(e, t) {
  try {
    return e.bc.postMessage(t, !1), f;
  } catch (r) {
    return Promise.reject(r);
  }
}
function ae(e, t) {
  e.messagesCallback = t;
}
function ue() {
  if (typeof globalThis < "u" && globalThis.Deno && globalThis.Deno.args)
    return !0;
  if ((typeof window < "u" || typeof self < "u") && typeof BroadcastChannel == "function") {
    if (BroadcastChannel._pubkey)
      throw new Error("BroadcastChannel: Do not overwrite window.BroadcastChannel with this module, this is not a polyfill");
    return !0;
  } else
    return !1;
}
function ce() {
  return 150;
}
var de = {
  create: oe,
  close: se,
  onMessage: ae,
  postMessage: ie,
  canBeUsed: ue,
  type: ne,
  averageResponseTime: ce,
  microSeconds: re
};
class $ {
  constructor(t) {
    v(this, "ttl");
    v(this, "map", /* @__PURE__ */ new Map());
    /**
     * Creating calls to setTimeout() is expensive,
     * so we only do that if there is not timeout already open.
     */
    v(this, "_to", !1);
    this.ttl = t;
  }
  has(t) {
    return this.map.has(t);
  }
  add(t) {
    this.map.set(t, O()), this._to || (this._to = !0, setTimeout(() => {
      this._to = !1, fe(this);
    }, 0));
  }
  clear() {
    this.map.clear();
  }
}
function fe(e) {
  const t = O() - e.ttl, r = e.map[Symbol.iterator]();
  for (; ; ) {
    const n = r.next().value;
    if (!n)
      return;
    const o = n[0];
    if (n[1] < t)
      e.map.delete(o);
    else
      return;
  }
}
function O() {
  return Date.now();
}
function E() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = JSON.parse(JSON.stringify(e));
  return typeof t.webWorkerSupport > "u" && (t.webWorkerSupport = !0), t.idb || (t.idb = {}), t.idb.ttl || (t.idb.ttl = 1e3 * 45), t.idb.fallbackInterval || (t.idb.fallbackInterval = 150), e.idb && typeof e.idb.onclose == "function" && (t.idb.onclose = e.idb.onclose), t.localstorage || (t.localstorage = {}), t.localstorage.removeTimeout || (t.localstorage.removeTimeout = 1e3 * 60), e.methods && (t.methods = e.methods), t.node || (t.node = {}), t.node.ttl || (t.node.ttl = 1e3 * 60 * 2), t.node.maxParallelWrites || (t.node.maxParallelWrites = 2048), typeof t.node.useFastPath > "u" && (t.node.useFastPath = !0), t;
}
var le = h, me = "pubkey.broadcast-channel-0-", u = "messages", w = {
  durability: "relaxed"
}, pe = "idb";
function D() {
  if (typeof indexedDB < "u")
    return indexedDB;
  if (typeof window < "u") {
    if (typeof window.mozIndexedDB < "u")
      return window.mozIndexedDB;
    if (typeof window.webkitIndexedDB < "u")
      return window.webkitIndexedDB;
    if (typeof window.msIndexedDB < "u")
      return window.msIndexedDB;
  }
  return !1;
}
function M(e) {
  e.commit && e.commit();
}
function he(e) {
  var t = D(), r = me + e, n = t.open(r);
  return n.onupgradeneeded = function(o) {
    var s = o.target.result;
    s.createObjectStore(u, {
      keyPath: "id",
      autoIncrement: !0
    });
  }, new Promise(function(o, s) {
    n.onerror = function(i) {
      return s(i);
    }, n.onsuccess = function() {
      o(n.result);
    };
  });
}
function ve(e, t, r) {
  var n = Date.now(), o = {
    uuid: t,
    time: n,
    data: r
  }, s = e.transaction([u], "readwrite", w);
  return new Promise(function(i, m) {
    s.oncomplete = function() {
      return i();
    }, s.onerror = function(c) {
      return m(c);
    };
    var a = s.objectStore(u);
    a.add(o), M(s);
  });
}
function ge(e, t) {
  var r = e.transaction(u, "readonly", w), n = r.objectStore(u), o = [], s = IDBKeyRange.bound(t + 1, 1 / 0);
  if (n.getAll) {
    var i = n.getAll(s);
    return new Promise(function(a, c) {
      i.onerror = function(l) {
        return c(l);
      }, i.onsuccess = function(l) {
        a(l.target.result);
      };
    });
  }
  function m() {
    try {
      return s = IDBKeyRange.bound(t + 1, 1 / 0), n.openCursor(s);
    } catch {
      return n.openCursor();
    }
  }
  return new Promise(function(a, c) {
    var l = m();
    l.onerror = function(y) {
      return c(y);
    }, l.onsuccess = function(y) {
      var p = y.target.result;
      p ? p.value.id < t + 1 ? p.continue(t + 1) : (o.push(p.value), p.continue()) : (M(r), a(o));
    };
  });
}
function we(e, t) {
  if (e.closed)
    return Promise.resolve([]);
  var r = e.db.transaction(u, "readwrite", w), n = r.objectStore(u);
  return Promise.all(t.map(function(o) {
    var s = n.delete(o);
    return new Promise(function(i) {
      s.onsuccess = function() {
        return i();
      };
    });
  }));
}
function ye(e, t) {
  var r = Date.now() - t, n = e.transaction(u, "readonly", w), o = n.objectStore(u), s = [];
  return new Promise(function(i) {
    o.openCursor().onsuccess = function(m) {
      var a = m.target.result;
      if (a) {
        var c = a.value;
        c.time < r ? (s.push(c), a.continue()) : (M(n), i(s));
      } else
        i(s);
    };
  });
}
function be(e) {
  return ye(e.db, e.options.idb.ttl).then(function(t) {
    return we(e, t.map(function(r) {
      return r.id;
    }));
  });
}
function _e(e, t) {
  return t = E(t), he(e).then(function(r) {
    var n = {
      closed: !1,
      lastCursorId: 0,
      channelName: e,
      options: t,
      uuid: _(),
      /**
       * emittedMessagesIds
       * contains all messages that have been emitted before
       * @type {ObliviousSet}
       */
      eMIs: new $(t.idb.ttl * 2),
      // ensures we do not read messages in parallel
      writeBlockPromise: f,
      messagesCallback: null,
      readQueuePromises: [],
      db: r
    };
    return r.onclose = function() {
      n.closed = !0, t.idb.onclose && t.idb.onclose();
    }, R(n), n;
  });
}
function R(e) {
  e.closed || x(e).then(function() {
    return B(e.options.idb.fallbackInterval);
  }).then(function() {
    return R(e);
  });
}
function Ee(e, t) {
  return !(e.uuid === t.uuid || t.eMIs.has(e.id) || e.data.time < t.messagesCallbackTime);
}
function x(e) {
  return e.closed || !e.messagesCallback ? f : ge(e.db, e.lastCursorId).then(function(t) {
    var r = t.filter(function(n) {
      return !!n;
    }).map(function(n) {
      return n.id > e.lastCursorId && (e.lastCursorId = n.id), n;
    }).filter(function(n) {
      return Ee(n, e);
    }).sort(function(n, o) {
      return n.time - o.time;
    });
    return r.forEach(function(n) {
      e.messagesCallback && (e.eMIs.add(n.id), e.messagesCallback(n.data));
    }), f;
  });
}
function Me(e) {
  e.closed = !0, e.db.close();
}
function Te(e, t) {
  return e.writeBlockPromise = e.writeBlockPromise.then(function() {
    return ve(e.db, e.uuid, t);
  }).then(function() {
    te(0, 10) === 0 && be(e);
  }), e.writeBlockPromise;
}
function ke(e, t, r) {
  e.messagesCallbackTime = r, e.messagesCallback = t, x(e);
}
function Ie() {
  return !!D();
}
function Pe(e) {
  return e.idb.fallbackInterval * 2;
}
var Se = {
  create: _e,
  close: Me,
  onMessage: ke,
  postMessage: Te,
  canBeUsed: Ie,
  type: pe,
  averageResponseTime: Pe,
  microSeconds: le
}, Ce = h, Le = "pubkey.broadcastChannel-", Be = "localstorage";
function N() {
  var e;
  if (typeof window > "u")
    return null;
  try {
    e = window.localStorage, e = window["ie8-eventlistener/storage"] || window.localStorage;
  } catch {
  }
  return e;
}
function J(e) {
  return Le + e;
}
function $e(e, t) {
  return new Promise(function(r) {
    B().then(function() {
      var n = J(e.channelName), o = {
        token: _(),
        time: Date.now(),
        data: t,
        uuid: e.uuid
      }, s = JSON.stringify(o);
      N().setItem(n, s);
      var i = document.createEvent("Event");
      i.initEvent("storage", !0, !0), i.key = n, i.newValue = s, window.dispatchEvent(i), r();
    });
  });
}
function Oe(e, t) {
  var r = J(e), n = function(s) {
    s.key === r && t(JSON.parse(s.newValue));
  };
  return window.addEventListener("storage", n), n;
}
function De(e) {
  window.removeEventListener("storage", e);
}
function Re(e, t) {
  if (t = E(t), !A())
    throw new Error("BroadcastChannel: localstorage cannot be used");
  var r = _(), n = new $(t.localstorage.removeTimeout), o = {
    channelName: e,
    uuid: r,
    eMIs: n
    // emittedMessagesIds
  };
  return o.listener = Oe(e, function(s) {
    o.messagesCallback && s.uuid !== r && (!s.token || n.has(s.token) || s.data.time && s.data.time < o.messagesCallbackTime || (n.add(s.token), o.messagesCallback(s.data)));
  }), o;
}
function xe(e) {
  De(e.listener);
}
function Ne(e, t, r) {
  e.messagesCallbackTime = r, e.messagesCallback = t;
}
function A() {
  var e = N();
  if (!e)
    return !1;
  try {
    var t = "__broadcastchannel_check";
    e.setItem(t, "works"), e.removeItem(t);
  } catch {
    return !1;
  }
  return !0;
}
function Je() {
  var e = 120, t = navigator.userAgent.toLowerCase();
  return t.includes("safari") && !t.includes("chrome") ? e * 2 : e;
}
var Ae = {
  create: Re,
  close: xe,
  onMessage: Ne,
  postMessage: $e,
  canBeUsed: A,
  type: Be,
  averageResponseTime: Je,
  microSeconds: Ce
}, U = h, Ue = "simulate", T = /* @__PURE__ */ new Set();
function je(e) {
  var t = {
    time: U(),
    name: e,
    messagesCallback: null
  };
  return T.add(t), t;
}
function We(e) {
  T.delete(e);
}
var j = 5;
function Fe(e, t) {
  return new Promise(function(r) {
    return setTimeout(function() {
      var n = Array.from(T);
      n.forEach(function(o) {
        o.name === e.name && // has same name
        o !== e && o.messagesCallback && // has subscribers
        o.time < t.time && o.messagesCallback(t);
      }), r();
    }, j);
  });
}
function Ve(e, t) {
  e.messagesCallback = t;
}
function ze() {
  return !0;
}
function qe() {
  return j;
}
var He = {
  create: je,
  close: We,
  onMessage: Ve,
  postMessage: Fe,
  canBeUsed: ze,
  type: Ue,
  averageResponseTime: qe,
  microSeconds: U
}, k = [
  de,
  // fastest
  Se,
  Ae
];
function Ke(e) {
  var t = [].concat(e.methods, k).filter(Boolean);
  if (e.type) {
    if (e.type === "simulate")
      return He;
    var r = t.find(function(o) {
      return o.type === e.type;
    });
    if (r)
      return r;
    throw new Error("method-type " + e.type + " not found");
  }
  e.webWorkerSupport || (t = t.filter(function(o) {
    return o.type !== "idb";
  }));
  var n = t.find(function(o) {
    return o.canBeUsed();
  });
  if (n)
    return n;
  throw new Error("No usable method found in " + JSON.stringify(k.map(function(o) {
    return o.type;
  })));
}
var W = /* @__PURE__ */ new Set(), Ge = 0, F = function(t, r) {
  this.id = Ge++, W.add(this), this.name = t, I && (r = I), this.options = E(r), this.method = Ke(this.options), this._iL = !1, this._onML = null, this._addEL = {
    message: [],
    internal: []
  }, this._uMP = /* @__PURE__ */ new Set(), this._befC = [], this._prepP = null, Xe(this);
};
F._pubkey = !0;
var I;
F.prototype = {
  postMessage: function(t) {
    if (this.closed)
      throw new Error("BroadcastChannel.postMessage(): Cannot post message after channel has closed " + /**
       * In the past when this error appeared, it was really hard to debug.
       * So now we log the msg together with the error so it at least
       * gives some clue about where in your application this happens.
       */
      JSON.stringify(t));
    return P(this, "message", t);
  },
  postInternal: function(t) {
    return P(this, "internal", t);
  },
  set onmessage(e) {
    var t = this.method.microSeconds(), r = {
      time: t,
      fn: e
    };
    C(this, "message", this._onML), e && typeof e == "function" ? (this._onML = r, S(this, "message", r)) : this._onML = null;
  },
  addEventListener: function(t, r) {
    var n = this.method.microSeconds(), o = {
      time: n,
      fn: r
    };
    S(this, t, o);
  },
  removeEventListener: function(t, r) {
    var n = this._addEL[t].find(function(o) {
      return o.fn === r;
    });
    C(this, t, n);
  },
  close: function() {
    var t = this;
    if (!this.closed) {
      W.delete(this), this.closed = !0;
      var r = this._prepP ? this._prepP : f;
      return this._onML = null, this._addEL.message = [], r.then(function() {
        return Promise.all(Array.from(t._uMP));
      }).then(function() {
        return Promise.all(t._befC.map(function(n) {
          return n();
        }));
      }).then(function() {
        return t.method.close(t._state);
      });
    }
  },
  get type() {
    return this.method.type;
  },
  get isClosed() {
    return this.closed;
  }
};
function P(e, t, r) {
  var n = e.method.microSeconds(), o = {
    time: n,
    type: t,
    data: r
  }, s = e._prepP ? e._prepP : f;
  return s.then(function() {
    var i = e.method.postMessage(e._state, o);
    return e._uMP.add(i), i.catch().then(function() {
      return e._uMP.delete(i);
    }), i;
  });
}
function Xe(e) {
  var t = e.method.create(e.name, e.options);
  ee(t) ? (e._prepP = t, t.then(function(r) {
    e._state = r;
  })) : e._state = t;
}
function V(e) {
  return e._addEL.message.length > 0 || e._addEL.internal.length > 0;
}
function S(e, t, r) {
  e._addEL[t].push(r), Ye(e);
}
function C(e, t, r) {
  e._addEL[t] = e._addEL[t].filter(function(n) {
    return n !== r;
  }), Qe(e);
}
function Ye(e) {
  if (!e._iL && V(e)) {
    var t = function(o) {
      e._addEL[o.type].forEach(function(s) {
        o.time >= s.time && s.fn(o.data);
      });
    }, r = e.method.microSeconds();
    e._prepP ? e._prepP.then(function() {
      e._iL = !0, e.method.onMessage(e._state, t, r);
    }) : (e._iL = !0, e.method.onMessage(e._state, t, r));
  }
}
function Qe(e) {
  if (e._iL && !V(e)) {
    e._iL = !1;
    var t = e.method.microSeconds();
    e.method.onMessage(e._state, null, t);
  }
}
export {
  F as B,
  ot as a,
  nt as b,
  st as c,
  tt as d,
  rt as f
};
//# sourceMappingURL=broadcast-channel-9128c16c.js.map
